import axios from "axios";
import { Category } from "../Category/CategoryApi";
import { Unit } from "../Unit/UnitApi";



export interface Item {
    id?: string;
    name: string;
    defaultUnit: Unit;
    category: Category;
    defaultQuantity?: number;
}

export async function fetchItems(): Promise<Item[]> {
    const response = await axios.get("/Item/get");
    return response.data;
}
export async function addItem(newItem: Item): Promise<Item> {
    const response = await axios.post("/Item/new", newItem);
    return response.data;
}
